import { bindable, customAttribute, inject } from "aurelia-framework";
import { Router } from "aurelia-router";

/**
 * Attribute to establish a click-handler on an element, which navigates to a
 * route when the element gets clicked.
 *
 * Usage:
 * <pre>
 * &lt;template>
 *   &lt;require from="./go-to-route">&lt;/require>
 *   &lt;div go-to-route="route: somewhere; params.bind: {...someParams}; options.bind: {...someOptions}">Go To Somewhere&lt;/div>
 * &lt;/template>
 * </pre>
 *
 * @see https://stackoverflow.com/a/41183859/1601438
 */
@customAttribute("k-goto-route")
@inject(Element, Router)
export class KGotoRoute {
  @bindable route;
  @bindable params;
  /** See History.NavigationOptions from 'aurelia-history' for possible options */
  @bindable options;

  constructor(
    private element: Element,
    private router: Router,
  ) {}

  attached() {
    this.element.addEventListener("click", () => {
      this.router.navigateToRoute(this.route, this.params, this.options);
    });
  }
}
